import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import type { FC } from 'react';

interface UnsavedChangesModalProps {
  opened: boolean;
  onClose: () => void;
  onDontSaveChanges: () => void;
  onSaveChanges: () => void;
  saveChangesIsPending: boolean;
}

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  opened,
  onClose,
  onSaveChanges,
  onDontSaveChanges,
  saveChangesIsPending,
}) => {
  const onCancel = () => {
    onClose();
  };

  return (
    <Modal
      centered
      opened={opened}
      size="lg"
      title={
        <Title component="span" order={3}>
          Unsaved Changes
        </Title>
      }
      onClose={onClose}
    >
      <Stack gap="xxxs">
        <Text size="xs">You have unsaved changes. Do you want to save them before returning to the dashboard?</Text>
        <Text c="red.5" size="xs">
          If you discard the changes, they will be lost.
        </Text>
        <Group gap="xxxs" justify="flex-end" mt="xxs" wrap="nowrap">
          <Button color="gray" radius="xl" size="md" variant="subtle" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="gray" radius="xl" size="md" variant="outline" onClick={onDontSaveChanges}>
            Discard
          </Button>
          <Button color="dark" loading={saveChangesIsPending} radius="xl" size="md" onClick={onSaveChanges}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
